module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/sections/20_gameShow/title_gameshow-brainstorm-bfd5bfb1a52e0de65e6dd8decada664e.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/20_gameShow/title_gameshow-brainstorm.png
// module id = 2512
// module chunks = 2